import type { ExportConfig } from '@/modules/export/models/ExportConfig';
import { json, data, config, componentType } from './export.state';

export function setJson(value: Params): void {
  json.value = value;
}

export function setData(value: Params): void {
  data.value = value;
}

export function setConfig(value: ExportConfig): void {
  config.value = value;
}

export function setComponentType(value: Params): void {
  componentType.value = value;
}
